import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="section bg-[#FCFBF6] text-gray-300">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-24">
        {/* Top Section */}
        <div className="flex flex-col md:flex-row md:flex-wrap gap-12 justify-between">
          {/* Logo + blurb */}
          <div className="flex-1 min-w-[220px]">
            <img
              src="/heartlandlogo.png"
              alt="Heartland Property Solutions Logo"
              className="mb-4 h-8 md:h-10 lg:h-11 w-auto"
            />
            <p className="mt-3 text-sm text-gray-400 leading-relaxed">
              Professional property management in the heart of Kansas. Local
              expertise. Exceptional service.
            </p>
          </div>

          {/* Quick Links */}
          <div className="flex-1 min-w-[180px]">
            <h4 className="text-sm font-semibold text-brand-black uppercase tracking-wider mb-4">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="/owners"
                  className="text-brand-black/70 hover:text-brand-black transition"
                >
                  For Owners
                </a>
              </li>
              <li>
                <a
                  href="https://heartlandpropertysolutions.appfolio.com/connect"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-black/70 hover:text-brand-black transition"
                >
                  Pay Rent
                </a>
              </li>
              <li>
                <a
                  href="https://heartlandpropertysolutions.appfolio.com/connect"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-black/70 hover:text-brand-black transition"
                >
                  Owner Portal
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="flex-1 min-w-[180px]">
            <h4 className="text-sm font-semibold text-brand-black uppercase tracking-wider mb-4">
              Contact
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="tel:+11234567890"
                  className="text-brand-black/70 hover:text-brand-black"
                >
                  785-338-0502
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@heartland.com"
                  className="text-brand-black/70  hover:text-brand-black"
                >
                  info@heartlandpropertysolutions.com
                </a>
              </li>
              <li className="text-brand-black/70 ">Saint Marys, KS</li>
            </ul>
          </div>

          {/* Social Media */}
          <div className="flex-1 min-w-[180px]">
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Follow Us
            </h4>
            <div className="flex space-x-4">
              <a
                href="#"
                className="hover:text-brand-black"
                aria-label="Facebook"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="#"
                className="hover:text-brand-black"
                aria-label="Twitter"
              >
                <i className="fab fa-twitter"></i>
              </a>
              <a
                href="#"
                className="hover:text-brand-black"
                aria-label="Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="#"
                className="hover:text-brand-black"
                aria-label="LinkedIn"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="mt-12 border-t border-gray-700 pt-6 flex flex-col sm:flex-row items-center justify-between text-sm text-gray-500">
          <p>
            © {new Date().getFullYear()} Heartland Property Solutions. All
            rights reserved.
          </p>
          <div className="flex gap-6 mt-4 sm:mt-0">
            <Link to="/privacy-policy" className="hover:text-[#F9DC5C]">
              Privacy Policy
            </Link>

            <Link to="/terms-of-service" clLinkssName="hover:text-[#F9DC5C]">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
